export default __webpack_public_path__ + "static/media/qrOverlay.185cc3ea.svg";